var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _ellipse2, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 261,
    viewBox: "0 0 160 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.603 249.115C188.897 237.59 149.638 198.008 119.5 194.5H39.7133C9.57496 198.008 -29.6046 237.457 34.6894 248.983C49.3354 252.295 61.1743 254.005 70.0905 254.792C67.5363 252.944 63.4208 243.793 79.7616 234.468C74.5101 231.436 67.1059 228.381 56.7917 225.55C65.4985 223.837 86.4283 221.578 100.492 226.247C91.3612 228.876 84.6472 231.68 79.7616 234.468C97.3545 244.626 90.7891 254.536 88.5398 254.982C97.5289 254.222 109.591 252.51 124.603 249.115Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7616 234.468C63.4208 243.793 67.5363 252.944 70.0905 254.792L79.7616 255.346C80.9095 255.37 81.9631 255.373 82.9217 255.36C84.6367 255.277 86.5099 255.154 88.5398 254.982C90.7891 254.536 97.3545 244.626 79.7616 234.468Z",
    fill: "#5D5D5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7616 255.346L70.0905 254.792L79.7616 260.5V255.346Z",
    fill: "#5D5D5D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5398 254.982C88.5044 254.989 88.573 254.98 88.5398 254.982L82.9217 255.36C81.8154 255.413 80.7359 255.324 79.7616 255.346V260.5L88.5398 254.982Z",
    fill: "#5D5D5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 82C25.6667 87.3333 21.7 97.8 16.5 97C21.1667 101.667 35.1 111 53.5 111H105.5C123.9 111 137.833 101.667 142.5 97C137.3 97.8 133.333 87.3333 132 82L130.5 73L29.5 70L27 82Z",
    fill: "#3B3D4B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.974 67.0002C129.307 65.3335 134.248 65.1981 136.648 69.1981C139.048 73.1981 135.648 78.1983 133.648 80.1984C131.981 81.6984 129.374 82.2005 122.974 81.0005C119.477 87.1543 108.752 98.472 90.9733 101.954C87.5655 102.621 83.8986 103.001 79.9739 103.001L76.9733 103.002C73.8724 103.002 70.9325 102.766 68.1541 102.337C67.7572 102.276 67.3636 102.211 66.9733 102.142C66.1119 101.99 65.2666 101.819 64.4374 101.632L64.3014 101.601C47.5217 97.7603 37.3588 86.9608 33.9733 81.0025C27.5733 82.2025 24.3144 81.6984 22.6477 80.1984C20.6477 78.1983 17.2477 73.198 19.6477 69.198C22.0477 65.198 27.64 65.3354 30.9733 67.0021C27.3067 49.6689 31.3733 14.3025 76.9733 11.5025C77.6404 11.5012 79.1744 11.499 79.9739 11.5005C125.574 14.3005 129.641 49.667 125.974 67.0002Z",
    fill: "#F8C5AD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9739 103.001L76.9733 103.002C73.8724 103.002 70.9325 102.766 68.1541 102.337C67.7572 102.276 67.3636 102.211 66.9733 102.142L66.0002 113C67.8336 116.5 72.7906 121.5 79.0002 121.5C83.5002 121.5 86.0002 122 92.0002 113.5L90.9733 101.954C87.5655 102.621 83.8986 103.001 79.9739 103.001Z",
    fill: "#F8C5AD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9727 50.4065C95.6393 47.7398 102.373 44.5065 107.973 52.9065",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.5 151C135.667 163 144.7 188.2 155.5 193C159.5 196.5 164.2 204 151 206C142.833 205.667 124.7 195.4 117.5 157L132.5 151Z",
    fill: "#F8C5AD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2002 151.5C24.0335 163.5 15.0002 188.7 4.2002 193.5C0.200195 197 -4.49981 204.5 8.7002 206.5C16.8669 206.167 35.0002 195.9 42.2002 157.5L27.2002 151.5Z",
    fill: "#F8C5AD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7861 159.448C43.1195 174.292 40.8106 190.384 38.1475 194.5C54.6475 196.5 94.2475 199.3 120.647 194.5C117.86 190.192 115.461 177.148 113.78 159.5C118.236 158.5 128.947 155.2 136.147 150C133.27 144.833 126.141 131.4 120.647 119C119.981 116.5 111.647 99.5 92.0002 107.5C91.1669 110.666 88.6477 120 79.1477 120C69.4153 120 66.8336 110.666 66.0002 107.5C44.7861 99.5 38.8141 116.5 38.1475 119C32.6535 131.4 25.525 144.833 22.6475 150C29.727 155.113 40.2016 158.389 44.7861 159.448Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9727 50.4065C63.306 47.7398 56.5727 44.5065 50.9727 52.9065",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.5,
    cy: 79.5,
    rx: 6.5,
    ry: 9,
    fill: "#D28F9B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.5,
    cy: 79.5,
    rx: 4.5,
    ry: 6,
    fill: "#F7F7F7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4997 0C110.666 0 124.409 16.5718 129.991 29.4688C133.837 38.3561 130.045 50.896 134.248 59.6208C134.899 60.9735 135.885 62.0062 137.366 62.5C138.866 63 140.366 66.5 131.866 67C124.86 67.4121 121.366 59.1485 121.366 51.5C121.366 46.7865 120.152 42.1505 117.627 38C102.427 43.6 86.1087 29.8333 80.4997 22C74.9654 29.7291 58.573 43.2346 43.5365 38.2133C42.0332 41.8906 41.0754 46.2884 40.5 51.5C39.6607 59.1023 37.1435 66.6827 30.1589 66C26.7671 65.6685 24.4913 65.2636 23.004 64.8341C19.3371 63.7753 25.1393 61.6924 26.5245 58.1359C28.068 54.173 27.6323 47.7054 27.9997 44.35C27.9997 36.5 33.4997 0 80.4997 0Z",
    fill: "#3B3D4B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9731 53.002C76.9731 57.002 71.973 65.002 78.9731 65.002C84.9731 65.002 80.9731 57.002 78.9731 53.002Z",
    fill: "#DB8861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson3);
export default __webpack_public_path__ + "static/media/person3.4349456f3b2b570e2cc329226db5ac84.svg";
export { ForwardRef as ReactComponent };